import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import { Link } from 'react-router-dom'

import Nav from './components/Nav'
import { ReactComponent as Star } from '../img/svg/star.svg'
import { ReactComponent as Round } from '../img/svg/icons/circle-solid.svg'
 
const Marker = ({ text, link }) => <div className="marker"><Link to={link}><button className="map-button">{text}</button></Link></div>;
const TextMarker = ({ text }) => <div className="map-col-2">
    <div className="center"> <Star className="alert-icon-sm"/></div>
    <div className="card"> {text}</div>
    </div>;
  const TextMarkerRound = ({ text }) => <div className="map-col-2">
  <div className="center"> <Round className="map-dot"/></div>
  <div className=""> {text}</div>
  </div>;
 
class SimpleMap extends Component {
    constructor(props) {
        super(props);
        this.state = { buttonLayer:true }
    }
  static defaultProps = {
      
    center: {
      lat: 39.25,
      lng: -106.705
    },
    zoom: 9
  };
 
  render() {
    return (
    <>
    <Nav />
        <div style={{ height: '70vh', width: '96%' }} className="card center">
        <GoogleMapReact
          bootstrapURLKeys={{ key:'AIzaSyDP_7k3QlxgVxo-c8hM4g14lDJlrv59oXQ'}}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom} >

    
       
         <TextMarkerRound
            text="Brush Creek"
            lat={39.05}
            lng={-106.94}
          />
         <TextMarkerRound
            text="Castle Creek"
            lat={39.10}
            lng={-106.8605471}
          />
         <TextMarkerRound
            text="Maroon Creek"
            lat={39.}
            lng={-106.9174094}
          />
         <TextMarkerRound
            text="Snowmass Creek"
            lat={39.3079662}
            lng={-106.9715136}
          />

          <TextMarkerRound
            text="Independence Pass"
            lat={39.165}
            lng={-106.59}
          />
     

        </GoogleMapReact>

      </div>
      </>
    );
  }
}
 
export default SimpleMap;